export default __webpack_public_path__ + "locales/ja-JP/PreparationPortal.json?hash=f5b14ea22815a5238fccf459b3cc586f";